export const ALL_CHAMBERS_SUCCESS = "ALL_CHAMBERS_SUCCESS";
export const ALL_CHAMBERS_FAILURE = "ALL_CHAMBERS_FAILURE";

export const SINGLE_CHAMBER_SUCCESS = "SINGLE_CHAMBER_SUCCESS";
export const SINGLE_CHAMBER_FAILURE = "SINGLE_CHAMBER_FAILURE";

export const FILTER_CHAMBER_SUCCESS = "FILTER_CHAMBER_SUCCESS";
export const FILTER_CHAMBER_FAILURE = "FILTER_CHAMBER_FAILURE";
